import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Header, Menu, Icon, Button } from "semantic-ui-react";
import EventDetailsPageHeader from "./EventDetailsPageHeader";

import request from "../../utils/request";
import { formatCurrency } from "../../utils/constants";
import { AppContext } from "../../utils/context";
import { isNumber } from "lodash";

class EventStats extends Component {
  _mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      summary: {},
      pollInterval: false,
      mobileNav: 'collapse',
      event: props && props.event ? props.event: {},
      shopifySalesDeactivated: props && props.event ? props.event.shopify_seller_deactivated: 0
    };
  }

  componentDidMount = () => {
    this._mounted = true;
    if (this.props.event.id > 0) this.pollData();
  };

  componentWillUnmount = () => {
    this._mounted = false;
    clearInterval(this.state.pollInterval); // clear pollInterval
  };

  startLoading = () => {
    this.setState({ loading: true });
  };

  doneLoading = () => {
    this.setState({ loading: false });
  };

  pollData = () => { // fetch event and event-summary data
    let self = this;
    self.startLoading();

    return request
      .get(this, `api:/event/${this.props.event.id}`)
      .then(resp => {
        if (!this._mounted) return false;
        self.setState({
          event: resp,
          shopifySalesDeactivated: resp.shopify_seller_deactivated
        });
        return resp;
      })
      .then(event => {
        request
          .get(this, `api:/event/${event.id}/summary`)
          .then(eventSummary => {
            if (!this._mounted) return false;
            self.setState({
              summary: eventSummary
            }, self.doneLoading);
            return eventSummary;
          }).then(event => {
            self.handlePoll(event);
            return true;
          });
        return event;
      })
  };

  handlePoll = resp => { // should invoke handlePoll() to make recursive pollData() calls
    if (!this._mounted) return false;
    if (resp.is_import_raffle > 0) clearInterval(this.state.pollInterval);
    if (resp.is_active === true) {
      if (!this.state.pollInterval) { // execute only if pollInterval is undefined
        let poll = setInterval(this.pollData, 15000);
        this.setState({
          pollInterval: poll
        });
      }
    }
  };

  handleClick = () => {
    const toggleNav = this.state.mobileNav === 'collapse' ? '' : 'collapse';
    this.setState({ mobileNav: toggleNav })
  };

  handleChange = () => {
    this.setState({ mobileNav: 'collapse' });
  };

  render() {
    const { route, eventId, pause } = this.props;
    const { loading, event, summary, mobileNav, shopifySalesDeactivated } = this.state;
    const { settings, config } = this.context;

    let devicesInUse = undefined;
    if (summary && summary.devices) {
        devicesInUse = summary.devices.total == 0 ? (0 + "%") : (((summary.devices.active / summary.devices.total) * 100).toFixed(0) + "%");
    }

    let tabs = [
        {
            key: "summary",
            name: "Summary",
            value: <Icon name="line chart" fitted />,
            prefix: false,
            importOnly: false,
            hidden: false
        },
        {
            key: "sellers",
            name: "Seller(s)",
            value: summary?.devices?.active ?? <Icon name="users" fitted />,
            prefix: false,
            importOnly: false,
            hidden: false
        },
        {
            key: "devices",
            name: "Device Use",
            value: devicesInUse ?? <Icon name="tablet" fitted />,
            prefix: false,
            importOnly: false,
            hidden: false
        },
        {
            key: "messages",
            name: "Message(s)",
            value: summary?.messages?.unread ?? <Icon name="envelope" fitted />,
            prefix: false,
            importOnly: false,
            hidden: event.rsu_enabled < 1 || event.is_addon > 0
        },
        {
            key: "import",
            name: "Tablet Import",
            value: <Icon name="upload" fitted />,
            prefix: false,
            importOnly: false,
            hidden: event.rsu_enabled < 1 || event.is_addon > 0
        },
        {
            key: "importer",
            name: "Importer",
            value: <Icon name="cloud upload" fitted />,
            prefix: false,
            importOnly: !event.prize_imports_enabled,
            hidden: false
        },
        {
            key: "winners",
            name: "Winners",
            value: <Icon name="trophy" fitted />,
            prefix: false,
            importOnly: false,
            hidden: false
        },
        {
            key: "payments",
            name: "Payments",
            value: formatCurrency(summary?.sales ? summary.sales.net : 0, config.language),
            prefix: "$",
            importOnly: false,
            hidden: false
        },
        {
            key: "reprint",
            name: "Reprints",
            value: summary?.tickets?.reprints ?? <Icon name="print" fitted />,
            prefix: false,
            importOnly: false,
            hidden: this.context && settings.option_backend_type !== 'bep' // hide reprint tab
        },
        {
            key: "cashdrops",
            name: "Cash Drops",
            value: <Icon name="money" fitted />,
            prefix: false,
            importOnly: false,
            hidden: (this.context && !config.cash_drops_enabled) || event.rsu_enabled < 1 // hide cash drops tab
        },
        {
            key: "voids",
            name: "Void Request(s)",
            value: summary?.voids?.new ?? <Icon name="ban" fitted />,
            prefix: false,
            importOnly: false,
            hidden: event.rsu_enabled < 1 || event.is_addon > 0
        },
        {
            key: "contributions",
            name: "Contributions",
            value: summary?.jackpot ? formatCurrency(summary.jackpot.contributions, config.language) : <Icon name="gift" fitted />,
            prefix: "$",
            importOnly: false,
            hidden: event.game_id === 2 || event.game_id === 4 // hide contributions tab for merch and calendar raffles
        },
        {
            key: "salesmap",
            name: "Sale Map",
            value: <Icon name="map" fitted />,
            prefix: false,
            importOnly: false,
            hidden: event.webenabled === 0 && event.shopify_enabled === 0
        }
    ];

    let newTabs = false;
    if (event.is_import_raffle > 0) { // is import raffle
        newTabs = tabs.filter(function(t) {
            return t && (t.key == 'winners' || t.importOnly);
        });
    } else {
        newTabs = tabs.filter(function(t) {
            return t && !t.importOnly && !t.hidden;
        });
    }

    return (
      <Container fluid style={{ top: '54px', left: '0px', zIndex: '5', background: '#fff' }}>
        <EventDetailsPageHeader
          event={event}
          summary={summary}
          pause={pause}
          shopifySalesDeactivated={shopifySalesDeactivated}
        />
        <Button
          id="btnNav"
          onClick={this.handleClick}
          fluid
          className={mobileNav === 'collapse' ? 'basic' : ''}>
          <Icon name="bars" />
          {mobileNav === 'collapse' ? 'Expand' : 'Collapse'} Navigation
        </Button>

        <Menu stackable widths={newTabs?.length ?? 0} pointing id="eventMenu" color="red" className={mobileNav}>
            {newTabs && newTabs.map((tab) => {
                return (<Menu.Item
                    active={route.params.action === tab.key}
                    as={Link}
                    to={`/events/${eventId}/${tab.key}`}
                    onClick={this.handleChange}
                    key={tab.key}
                >
                <Header as="h4" icon color={loading ? "grey" : "black"}>
                    <Header.Content>{tab.prefix && isNumber(tab.value) ? tab.prefix : ""}{tab.value}</Header.Content>
                    <Header.Content>{tab.name}</Header.Content>
                </Header>
            </Menu.Item>)
            })}
        </Menu>
      </Container>
    );
  }
}

EventStats.contextType = AppContext;

export default EventStats;
